import { cva, type VariantProps } from 'class-variance-authority'
import { memo, type ReactNode } from 'react'

import { cn } from '@/lib/utils'

const chatMessageBubbleVariants = cva(
  'min-w-0 rounded-2xl px-4 py-2.5 break-words overflow-x-auto overflow-y-hidden select-text',
  {
    variants: {
      variant: {
        user: 'bg-primary text-primary-foreground rounded-br-md',

        assistant: 'bg-muted text-foreground rounded-bl-md',

        system: 'bg-muted/50 text-muted-foreground text-sm italic',

        note: 'bg-yellow-100 dark:bg-yellow-900/30 text-foreground rounded-br-md border border-yellow-200 dark:border-yellow-800',

        error: 'bg-destructive/10 text-destructive border border-destructive/30 rounded-bl-md',
      },
    },
    defaultVariants: {
      variant: 'assistant',
    },
  }
)

export interface ChatMessageBubbleProps extends VariantProps<typeof chatMessageBubbleVariants> {
  children: ReactNode

  className?: string

  onClick?: () => void
}

const ChatMessageBubbleBase: React.FC<ChatMessageBubbleProps> = ({
  variant,
  children,
  className,
  onClick,
}) => {
  const bubbleClass = cn(chatMessageBubbleVariants({ variant }), className)

  if (onClick) {
    return (
      <button
        type="button"
        className={cn(bubbleClass, 'cursor-pointer text-left')}
        onClick={onClick}
      >
        {children}
      </button>
    )
  }

  return <div className={bubbleClass}>{children}</div>
}

export const ChatMessageBubble = memo(ChatMessageBubbleBase)

ChatMessageBubble.displayName = 'ChatMessageBubble'

export { chatMessageBubbleVariants }
